// extracted by mini-css-extract-plugin
export default {"container":"_2K7GKmuR4lAAM8Ftq_lRdx","left":"_3x-ruhbdRRxmBrReHuoO8k","team":"yfeDnpIFYmRzJ52GVKEwg","score":"_3nw8mdfyjBXTSPrWnWKfjr","growth":"lQRPF9TdPwsvx-Ko1c4fA"};